import React from 'react';
import styled from 'styled-components';
import { NextPage } from 'next';
import { defaultTheme } from 'constants/theme/defaultTheme';
import { VerifyEmail } from 'components/VerifyEmail/VerifyEmail';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20vh;
  background-color: ${defaultTheme.colors.white};
  height: 100vh;
`;

const Verify: NextPage = () => {
  return (
    <Wrapper>
      <VerifyEmail />
    </Wrapper>
  );
};

export default Verify;
